// Detalle del combustible y el desgaste del transporte (precio real del día en
// la gasolinera habitual, consumo y desgaste de cada furgoneta). Lee el bloque
// `combustible` que devuelve el backend en el estado de reglas
// (`estadoReglas.transporte.combustible`) o en `transporte.combustible` del
// presupuesto. Líneas pequeñas en gris; los avisos, en ámbar. El desgaste va
// como km × €/km, sin valor de compra ni vida útil (eso, en la ficha).
import React from 'react';

// Avisos que se enseñan en el presupuesto. Los del desgaste (valor de compra,
// vida útil, cuota del renting) solo van en la ficha de la furgoneta; se
// filtran también aquí por si llega un bloque guardado antiguo.
export const avisosPresupuesto = (avisos) => (Array.isArray(avisos) ? avisos : [])
  .filter(a => typeof a === 'string' && !/valor de compra|vida útil|amortizaci|cuota o los km/i.test(a));

const DetalleCombustible = ({ combustible, className = 'block text-xs', testid = 'detalle-combustible' }) => {
  if (!combustible) return null;
  const c = combustible;
  const desgastes = Array.isArray(c.desgastes) ? c.desgastes : [];
  const avisos = avisosPresupuesto(c.avisos);
  // Sin precio del Ministerio (o presupuesto anterior): una sola línea con la tarifa fija
  const lineaCombustible = c.texto_combustible || c.texto;
  return (
    <span className="flex flex-col" data-testid={testid}>
      {lineaCombustible && <span className={className}>{lineaCombustible}</span>}
      {!c.sin_dato && desgastes.map((d) => (
        <span key={d.texto} className={className}>Desgaste {d.texto}</span>
      ))}
      {c.nota && <span className={`${className} italic`}>{c.nota}</span>}
      {avisos.map((a) => (
        <span key={a} className={`${className} text-[#92400E]`}>{a}</span>
      ))}
    </span>
  );
};

export default DetalleCombustible;
